import curry from "../curry.js";
import { bindActionCreators } from "redux";

let withActions = (actionObject, f) => (dispatch, getState, context) =>
  f({ dispatch, getState, context }, bindActionCreators(actionObject, dispatch));

withActions = curry(2, withActions);

export default withActions;
